// extracted by mini-css-extract-plugin
module.exports = {"legendColor":"LegendKeys_legendColor__2ym7B","legendKey":"LegendKeys_legendKey__1b1Yl"};